import React, { Component } from 'react'
import http from 'src/helper/http'
import './index.less'
import langM from './lang'
import {
  setDocumentTitle,
  setUidToken,
  showConsole,
  getlang,
  setlang,
  score,
  unix2date6,
  forbidScroll,
  jumpToUser,
  jumpToRoom,
  debounce,
  throttle,
  inject,
  observer,
  openViewTransparent,
  closeWebViewPage,
  closeWebview
} from '../../../helper/devTools.js'

import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css';
import localstorage from 'src/helper/localstorage'


@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    // this.welfareStore = this.props.store.register('activity/welfare')
    setDocumentTitle('APP GAME')
  }
  state = {
    messageTxt: "",
    currentNum: 500,
    enoughTip: false,
    exchangeTip: false,
    popUpShow: false,
    uid: 0,
    accesstoken: '',
    typeStatus: 1,
    rankList: [],
    recordList: [],
    myRank: {},
    scrollParams: "0,30",
    hasMore: false,
    lang:langM.en,
  }

  async initLang() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    console.log('language', language)
    // if (language==ar) {
    //   storage.setItem("language", "ar")
    // }else{
    //   storage.setItem("language", "en")
    // }
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }

  async getMoreList() {
    let recordL = await this.getRecordList(this.state.scrollParams)
    let list = this.state.recordList
    recordList && recordList.res && recordList.res.list.map((i) => {
      list.push(i)
    })
    this.setState({
      recordL: list,
      hasMore: recordL && recordL.res && recordL.res.hasMore,
      scrollParams: recordL && recordL.res && recordL.res.scroll,
    })
  }

  async componentDidMount() {
    this.initLang()
    let uid = await this.initUid()
    await this.RunOnStart(uid)

    let rankL = await this.getRankList()
    let recordL = await this.getRecordList(this.state.scrollParams)
    console.log(rankL)
    console.log(recordL)
    this.setState({
      rankList: rankL,
      recordList: recordL && recordL.res && recordL.res.list,
      scrollParams: recordL && recordL.res && recordL.res.scroll,
    })

    // const wn = document.getElementById('app-games-iframe-main').contentWindow;
    // console.log(wn)
    // wn.postMessage('Hello to iframe from parent!', 'http://192.168.0.40:8000/#/app/appgames');

    // window.addEventListener('message', this.handleMessage, false);
  }

  handleMessage(event) {
    // MDN 建议在处理消息前要先检查发送方的域名，防止恶意消息
    if (event.origin === 'http://192.168.0.40:8000/#/app/appgames') {
      // 处理消息
      console.log(event, 'event')
      // 发送回执给发送方
      event.source.postMessage('Message received', event.origin);
    }
  }

  // 初始化/接口请求初始化
  RunOnStart = async () => {

    const { uid, accesstoken } = localstorage.get('userInfo')
    this.setState({
      uid: uid,
      accesstoken: accesstoken,
    })

    // try {
    //   this.setState({
    //     uid: uid
    //   })
    //   let getUserInfo = await this.welfareStore.GetUserInfoWeb(uid)
    //   if (getUserInfo && getUserInfo.code == 0) {
    //     this.setState({
    //       userInfo: getUserInfo.res
    //     })
    //   }
    // } catch (error) {
    //   console.error(error)
    //   this.refs.msg.show("error")
    // }
  }

  async getRankList() {
    let result = await http.post('/web/slot/rank')
    this.setState({
      myRank: result && result.res && result.res.myrank
    })
    return result && result.res && result.res.list
  }
  async getRecordList(v) {
    let result = await http.post('/web/slot/gold/record', { scroll: v })
    return result
  }

  changeNum(num) {
    this.setState({
      currentNum: num
    })
  }
  goExchange(type) {
    if (type == 1) {
      this.setState({
        enoughTip: false
      })
    }
    if (type == 2) {
      this.setState({
        enoughTip: false,
        exchangeTip: true
      })
    }
  }

  post1 = async (msg) => {
    // 第一步,要拿到iframe,这里主要是拿到iframe.contentWindow
    let iframe = document.getElementById('app-games-iframe-main')
    let iframeWindow = iframe.contentWindow // 利用iframe.contentWindow 也就是4.html 的window对象.
    let map = { "msgtp": "refresh", "content": "这里是发送的内容1" }
    // iframeWindow.postMessage(JSON.stringify(map),'http://localhost:8000') // 第二个参数,指定4.html的域名
    iframeWindow.postMessage(JSON.stringify(map), 'http://47.243.131.25') // 第二个参数,指定4.html的域名

  }

  render() {
    let list = [
      500,
      1000,
      2000,
      5000
    ]

    return (
      <div className={`app-games-wrapper`}>
        <div className="bg"></div>
        <div className="app-games-content">

          <div className="tip-exchange" style={{ display: `${this.state.exchangeTip ? "block" : "none"}` }}>
            <div className="title">
              Gold exchange
            </div>
            <div className="content">
              <div className="c-items">
                {
                  list.map((i, k) => {
                    return (
                      <div className={`item ${this.state.currentNum == i && "item-active"}`} key={k} onClick={() => { this.changeNum(i) }}>
                        {i}
                      </div>
                    )
                  })
                }
              </div>
              <div className="bottom">
                <div className="close" onClick={() => { this.setState({ exchangeTip: false }) }}>close</div>
                <div className="yes">confirm</div>
              </div>
              <div className="desc">
                Click the extract button to manually extract gold
              </div>
            </div>
          </div>

          <div className="tip-not-enough" style={{ display: `${this.state.enoughTip ? "block" : "none"}` }}>
            <div className="content">
              You don't have enough
              coins to play slot
            </div>
            <div className="bottom">
              <div className="btn1" onClick={() => { this.goExchange(1) }}>later</div>
              <div className="btn2" onClick={() => { this.goExchange(2) }}>exchange</div>
            </div>
          </div>

          <div className="app-games-tab">
            <div className="left">
              <div className="tab-item">
                {/* <img src="/img/app/appgames/i1.png" alt="" /> */}
              </div>
              <div className="tab-item">
                {/* <img src="/img/app/appgames/i2.png" alt="" /> */}
              </div>
            </div>
            <div className="right">
              <div className="tab-item">
                <img src="/img/app/appgames/i4.png" alt="" onClick={() => { this.setState({ typeStatus: 2, popUpShow: true }) }} />
              </div>
              <div className="tab-item">
                <img src="/img/app/appgames/i5.png" alt="" onClick={() => { this.setState({ typeStatus: 1, popUpShow: true }) }} />
              </div>
              <div className="tab-item">
                <img src="/img/app/appgames/i3.png" alt="" onClick={() => { closeWebview() }} />
              </div>
            </div>
          </div>

          <iframe
            className="app-games-iframe"
            id='app-games-iframe-main'
            src={`https://ala-web.chatie.live/index.html?uid=${this.state.uid}&token=${this.state.accesstoken}&avatar=http://img.chatie.live/app/man.jpg`}
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture">
          </iframe>

          <div className="list-content" style={{ transform: `translateY(${this.state.popUpShow ? "0" : "100vh"})` }}>
            <div className="close" onClick={() => { this.setState({ popUpShow: false }) }}></div>
            <div className="title">
              {this.state.typeStatus == 1 && "Rank"}
              {this.state.typeStatus == 2 && "My records"}
            </div>
            <div className="rank-items" style={{ height: `${this.state.typeStatus == 2 ? '8.1rem' : '7.08rem'}`, }}>
              {
                this.state.rankList && this.state.rankList.map((i, k) => {
                  return (
                    <div className="item" style={{ display: `${this.state.typeStatus == 1 ? "flex" : "none"}` }} key={k}>
                      <div className="rank-index">
                        {
                          i.rank == "1" && <img src="/img/app/appgames/t1.png" alt="" />
                        }
                        {
                          i.rank == "2" && <img src="/img/app/appgames/t2.png" alt="" />
                        }
                        {
                          i.rank == "3" && <img src="/img/app/appgames/t3.png" alt="" />
                        }
                        {
                          i.rank != "1" && i.rank != "2" && i.rank != "3" && i.rank
                        }
                      </div>
                      <div className="avatar">
                        <img src={i.avatarurl} alt="" />
                      </div>
                      <div className="info">
                        <div className="name">{i.nickname}</div>
                        <div className="id">ID:{i.duid}</div>
                      </div>
                      <div className="gold">
                        <img src="/img/gold.png" alt="" />
                        <span>{score(i.val)}</span>
                      </div>
                    </div>
                  )
                })
              }
              {
                this.state.recordList && this.state.recordList.map((i, k) => {
                  return (
                    <div className="item" style={{ display: `${this.state.typeStatus == 2 ? "flex" : "none"}` }} key={k}>
                      <div className="pic">
                        <img src="/img/gold.png" alt="" />
                      </div>
                      <div className="num">{i.coins}</div>
                      <div className="date">{i.date}</div>
                    </div>
                  )
                })
              }
              {
                this.state.typeStatus == 2 && this.state.hasMore && (
                  <div className="more" onClick={() => { this.getMoreList() }}>More</div>
                )
              }
            </div>

            <div className="item my-rank" style={{ display: `${this.state.typeStatus == 1 && this.state.myRank.uid ? "flex" : "none"}` }}>
              <div className="rank-index">
                {
                  this.state.myRank && this.state.myRank.rank == "1" && <img src="/img/app/appgames/t1.png" alt="" />
                }
                {
                  this.state.myRank && this.state.myRank.rank == "2" && <img src="/img/app/appgames/t2.png" alt="" />
                }
                {
                  this.state.myRank && this.state.myRank.rank == "3" && <img src="/img/app/appgames/t3.png" alt="" />
                }
                {
                  this.state.myRank && this.state.myRank.rank != "1" && this.state.myRank.rank != "2" && this.state.myRank.rank != "3" && this.state.myRank.rank
                }
              </div>
              <div className="avatar">
                <img src={this.state.myRank && this.state.myRank.avatarurl} alt="" />
              </div>
              <div className="info">
                <div className="name">{this.state.myRank && this.state.myRank.nickname}</div>
                <div className="id">ID:{this.state.myRank && this.state.myRank.duid}</div>
              </div>
              <div className="gold">
                <img src="/img/gold.png" alt="" />
                <span>{score(this.state.myRank && this.state.myRank.val)}</span>
              </div>
            </div>

          </div>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/appgames/index.js